import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="ui--space-selector"
// Handles opening the modal and submitting the form
export default class extends Controller {
  static values = {
    modalId: String,
  }

  get modal() {
    return document.getElementById(this.modalIdValue)
  }

  openModal(event) {
    event.preventDefault()
    event.stopPropagation()

    const modal = this.modal
    if (!modal) {
      console.error(
        "Space selector: Modal not found with ID:",
        this.modalIdValue,
      )
      return
    }

    // Try to get the Stimulus controller
    const modalController =
      this.application.getControllerForElementAndIdentifier(modal, "ui--modal")

    if (modalController && typeof modalController.open === "function") {
      modalController.open()
    } else {
      // Fallback: use native dialog showModal directly
      if (typeof modal.showModal === "function") {
        modal.showModal()
      } else {
        console.error("Space selector: Modal element doesn't support showModal")
      }
    }
  }

  submitForm(event) {
    event.preventDefault()
    // Find the form inside the modal and submit it
    const form = this.modal?.querySelector("form")
    if (form) {
      form.submit()
    }
  }
}
